/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class PreventiveSheetAttachmentViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, preventiveSheetAttachmentService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, $mdDialog, data) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.preventiveSheetAttachmentService = preventiveSheetAttachmentService;
        this.$mdDialog = $mdDialog;
        this.preventiveSheetId = data.preventiveSheetId;
        this.$log.debug('Controller \'PreventiveSheetAttachmentViewController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn(
                'PreventiveSheetAttachmentViewController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            super.$onInit();

            this.equipmentAttachment = true;
            this.formDisabled = false;
            this.initialized = true;
        }
    }

    /**
     * Converts this form data to valid DTO (form multiparts).
     *
     * @return {Object} Form multiparts, indexed by name.
     */
    convertToDto() {
        const formData = {
            attachments: this.attachments,
            equipmentAttachment: this.equipmentAttachment
        }
        return formData;
    }

    save() {
        if (this.areAttachmentsValid(this.attachments)) {
            this.formDisabled = true;
            this.handleRestServiceCall(
                this.preventiveSheetAttachmentService.createEntityWithUpload(
                    {preventiveSheetId: this.preventiveSheetId},
                    this.convertToDto()
                ), () => {
                    this.notificationService.pushMessage('ui.preventivesheet.attachmentsadded',
                        this.configuration.NOTIFIER_LEVEL_INFO);
                    this.$mdDialog.hide(true);
                }
            ).finally(() => {
                this.formDisabled = false;
            });
        }
    }

    cancel() {
        this.$mdDialog.hide(false);
    }
}

export { PreventiveSheetAttachmentViewController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/component/PreventiveSheetAttachmentView.js